/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForAzureEaMaster extends models.ServiceAccountNativeDetailsBaseForAzure {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForAzureEaMaster");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForAzureEaMaster.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForAzureEaMaster>): ServiceAccountNativeDetailsBaseForAzureEaMaster {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForAzureEaMaster(), model);
        ServiceAccountNativeDetailsBaseForAzureEaMaster.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForAzureEaMaster>): ServiceAccountNativeDetailsBaseForAzureEaMaster {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForAzureEaMaster.newInstance(<ServiceAccountNativeDetailsBaseForAzureEaMaster> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForAzureEaMaster) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForAzureEaMaster.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForAzureEaMaster): boolean {
        if (models.ServiceAccountNativeDetailsBaseForAzure.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForAzureEaMaster.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Enrollment Id. This is a required field.
     */
    enrollment_id: string;

}
